import {Route, Routes, Navigate} from "react-router-dom";
import {Catalog} from "./components/Catalog/Catalog";
import {Profile} from "./components/Profile/Profile";
import {Login} from "./components/Login/Login";
import NavbarContainer from "./components/Navbar/Navbar";
import useToken from "./components/Hooks/useToken";
import {Cart} from "./components/Cart/Cart";
import {NotificationWrapper} from "./components/Notifications/NotificationsWrapper"
import {CartContextProvider} from "./Context/CartContext";
import {SalesOrderHistory} from "./components/SalesOrderHistory/SalesOrderHistory";

import './App.css';
import "primereact/resources/themes/saga-orange/theme.css";  //theme
import "primereact/resources/primereact.min.css";//core css
import "primeicons/primeicons.css";
import { locale, addLocale } from 'primereact/api';
import {MarketingStockWrapper} from "./components/MarketingStock/MarketingStockWrapper";
import {MarketingStockPage} from "./components/MarketingStock/MarketingStockPage/MarketingStockPage";
import {NotificationProvider} from "./Context/NotificationContext"
import { NotificationPage } from './components/Notifications/NotificationPage/NotificationPage';
import {NotificationToast} from './components/Notifications/NotificationToast'
import { LubematchPage } from './components/Lubematch/LubematchPage';

function App() {
    const {token, setToken} = useToken();

    addLocale('uk', {
        firstDayOfWeek: 1,
        dayNames: ['неділя', 'понеділок', 'вівторок', 'середа', 'четвер', 'п’ятниця', 'субота'],
        dayNamesShort: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
        dayNamesMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthNames: ['січень', 'лютий', 'березень', 'квітень', 'травень', 'червень', 'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень'],
        monthNamesShort: ['січ', 'лют', 'бер', 'кві', 'тра', 'чер', 'лип', 'сер', 'вер', 'жов', 'лис', 'гру'],
        today: 'Сьогодні',
        clear: 'Очистити'
      });
      
      locale('uk');

    if (!token) {
        const currentRedirectUrl = sessionStorage.getItem('redirectUrl');
        if(!currentRedirectUrl){
            sessionStorage.setItem('redirectUrl', window.location.pathname);
        }
        return <Login token={token} setToken={setToken}/>
    }

    return (
        <div className="App">
            <CartContextProvider>
                <NotificationProvider>
                    <NotificationToast />

                    <header className="App-header">
                        <NavbarContainer setToken={setToken} />
                    </header>
                    
                    <main className='App-container'>
                        <div className='App-container-inner'>
                            <Routes>
                                <Route exact path="/" element={<Navigate to="/catalog" />}/>
                                <Route path='/history'
                                       element={<SalesOrderHistory />}/>
                                <Route path='/catalog'
                                       element={<Catalog />}/>
                                <Route path='/lubematch'
                                       element={<LubematchPage />}/>
                                 <Route path='/notifications'
                                       element={<NotificationWrapper />}/>
                                 <Route path="/notifications/:id" element={<NotificationPage />} />
                                <Route path='/marketingStockWrapper'
                                       element={<MarketingStockWrapper/>}/>
                                <Route path="/stock/:id" element={<MarketingStockPage />} />
                                <Route path='/profile'
                                       element={<Profile />}/>
                                <Route path='/login'
                                       element={<Login  setToken={setToken}/>}/>
                                <Route path='/cart'
                                       element={<Cart  />}/>
                            </Routes>
                        </div>
                    </main>
                </NotificationProvider>
            </CartContextProvider>
        </div>
    )
}

export default App;
